// src/pages/admin/AdminLogin.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginAdmin } from "./auth";
import oakyaLogo from "../../assets/contactBlogCareer/oakya-it-services.webp";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./AdminLogin.css";

const AdminLogin = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    // Validation
    const newErrors = {};

    if (!userName.trim()) newErrors.userName = "Username is required";
    if (!password.trim()) newErrors.password = "Password is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fill in all required fields");
      return;
    }

    setErrors({});
    setIsLoading(true);

    // Show loading toast
    const loadingToastId = toast.loading("Verifying credentials...");

    // Simulate a small delay for better UX
    setTimeout(() => {
      // Use the loginAdmin function from auth.js
      const success = loginAdmin(userName, password);

      if (success) {
        // Update loading toast to success
        toast.update(loadingToastId, {
          render: "Login successful! Redirecting to dashboard...",
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });
        
        setTimeout(() => {
          navigate("/admin-control-panel/dashboard");
        }, 1000);
      } else {
        // Update loading toast to error
        toast.update(loadingToastId, {
          render: "Invalid Username or Password",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
      
      setIsLoading(false);
    }, 800);
  };

  // ENTER KEY HANDLER
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !isLoading) {
      handleLogin();
    }
  };

  return (
    <div className="admin-login-page">
      {/* Toast Container for admin login */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        limit={3}
      />

      <div className="admin-login-card">
        {/* Logo */}
        <div className="admin-login-logoWrap">
          <img src={oakyaLogo} alt="Oakya IT Services" />

          <div
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginTop: "10px",
              color: "#111",
            }}
          >
            Oakya IT Services
          </div>

          <div className="admin-subtitle">Admin Login</div>
          <div className="admin-accentBar"></div>
        </div>

        {/* Username */}
        <div className="admin-field">
          <label>Username</label>
          <input
            type="text"
            placeholder="Enter your username"
            value={userName}
            onChange={(e) => {
              setUserName(e.target.value);
              setErrors((p) => ({ ...p, userName: "" }));
            }}
            onKeyDown={handleKeyDown}
            disabled={isLoading}
            autoComplete="off"
          />
          {errors.userName && <span className="error">{errors.userName}</span>}
        </div>

        {/* Password */}
        <div className="admin-field">
          <label>Password</label>

          <div className="password-wrap">
            <input
              type={showPass ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrors((p) => ({ ...p, password: "" }));
              }}
              onKeyDown={handleKeyDown}
              disabled={isLoading}
              autoComplete="off"
            />

            <span className="toggle-icon" onClick={() => setShowPass((v) => !v)}>
              <i className={showPass ? "fas fa-eye-slash" : "fas fa-eye"}></i>
            </span>
          </div>

          {errors.password && <span className="error">{errors.password}</span>}
        </div>

        {/* Button */}
        <button className="login-btn" onClick={handleLogin} disabled={isLoading}>
          {isLoading ? "Logging in..." : "Login"}
        </button>

        <div className="note">Only authorized personnel may access this portal.</div>
      </div>
    </div>
  );
};

export default AdminLogin;